/**
 * Mocked squadron used across the explore pages. Realistic numbers,
 * British military-callsign-style naming — reads as "this is a real
 * squadron" not "this is placeholder data". One squadron used by all
 * explore pages so the brand reads as coherent across the journey.
 *
 * Values picked to land at the sweet spot of "growing seriously":
 *   - L3 tier so paid-tournament + bracket features are unlocked
 *   - 47 / 300 members so the growth-room is visible
 *   - £612 / month revenue from member fees
 *   - 4 paid tournaments hosted, 1 currently running
 */
export const MOCK_SQUADRON = {
  id: 'mock-squadron-blackline',
  name: 'BLACKLINE',
  tag: '[BLK]',
  description:
    'UK-based military gaming squad. Tactical FPS, esports nights, weekly bracket play.',
  logoUrl: 'https://api.dicebear.com/7.x/initials/svg?seed=BLACKLINE&backgroundColor=2E5BFF&textColor=ffffff',
  tier: 'LEVEL_3' as const,
  tierLabel: 'Gold',
  memberCount: 47,
  memberCap: 300,
  memberMonthlyFeePence: 1500,            // £15 / month
  monthlyRevenuePence: 612 * 100,         // 47 × £15 - some lapsed = £612
  monthlyRevenueGrowthPct: 12,
  paidTournamentsHostedAllTime: 4,
  paidTournamentsLast30d: 1,
  totalPrizePoolDistributedPence: 168_000, // £1,680
  ownerName: 'CMDR Halcyon',
  ownerCallsign: '@halcyon',
  ownerVerified: true,
  ownerMilitaryBranch: 'British Army',
  squadronVerified: true,
  squadronVerifiedDomain: 'mod.uk',
  discordGuildName: 'BLACKLINE Operations',
  discordConnected: true,
  paymentSetupComplete: true,
  createdAt: '2025-08-12T00:00:00Z',
}

export type MockSquadron = typeof MOCK_SQUADRON
